import React from 'react'
import Login from '../../Components/LoginComponent/Login'

const LoginPage = () => {
  return (
    <div>
        <Login/>
    </div>
  )
}

export default LoginPage
